module.exports = __webpack_public_path__ + "static/media/sideBarStar.8347cb3e.svg";